export const DOWNLOAD_CASE_TEMPLATE_PENDING = '[CASE_UPLOAD][DOWNLOAD] Download Case Template pending';
export const DOWNLOAD_CASE_TEMPLATE_SUCCESS = '[CASE_UPLOAD][DOWNLOAD] Download Case Template success';
export const DOWNLOAD_CASE_TEMPLATE_FAILURE = '[CASE_UPLOAD][DOWNLOAD] Download Case Template failure';

export const GET_UPLOADED_CASES_SUCCESS = '[CASE_UPLOAD][GET] get Uploaded Cases success';
export const GET_UPLOADED_CASES_FAILURE = '[CASE_UPLOAD][GET] get Uploaded Cases failure';

//Case Filter
export const CLEAR_FILTER = 'case upload clear filter';
export const ON_CHANGE = 'case upload on change';
export const ON_CHANGE_DATE = 'case upload on change date';

// modal
export const SHOW_FILTER_MODAL = '[CASE_UPLOAD][FILTERS] toggle Modal';
// export const HYDRATE_CASES = '[CASE_UPLOAD][DOCUMENTS] hydrate case documents';
// export const HYDRATE_CASES_FILTERS = '[CASE_UPLOAD][FILTERS] hydrate filters';
export const APPLY_CASES_FILTERS = '[CASE_UPLOAD][FILTERS] apply filters';
export const APPLY_CASES_FILTERS_SUCCESS = '[CASE_UPLOAD][FILTERS] apply filters success';
export const APPLY_CASES_FILTERS_FAILURE = '[CASE_UPLOAD][FILTERS] apply filters failure';
export const GET_FILTERS_SUCCESS = '[CASE_UPLOAD][FILTERS] get case filters';

//case upload
export const CASE_UPLOAD_PENDING = '[CASE_UPLOAD][PENDING] case upload pending';
export const CASE_UPLOAD_FAILURE = '[CASE_UPLOAD][FAILURE] case upload failure';
export const SET_IMPORT_JOB_ID = '[CASE_UPLOAD][UPLOAD] set import job id';
export const RESET_CASE_UPLOAD = '[CASE_UPLOAD][RESET] reset case upload ';
export const SAVE_CASE_UPLOAD = '[CASE_UPLOAD][SAVE] save case upload ';
